import { api } from "./api";

const ENDPOINT =
  process.env.REACT_APP_ENVIRONMENT === 'production'
    ? process.env.REACT_APP_BASE_URL_API_SERVER_PROD
    : process.env.REACT_APP_BASE_URL_API_SERVER_TEST;

export async function enviarCodigoConfirmacao(cpf, numero) {
  if (!cpf || !numero) {
    throw new Error('CPF e número de telefone são obrigatórios');
  }

  const response = await api(`${ENDPOINT}/sms/codigo-confimacao/enviar`, {
    credentials: 'include',
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      cpf,
      numero,
      sms: true,
    }),
  });

  return await response.json();
}
